export class IpexServiceProviderCount {
    connectedCaseCount: number;
    serviceProviderId: string;
}
